import domainImport from './routes.domain';
import byId from './routes.byId';
import byCategory from './routes.byCategory';
import byTemplate from './routes.byTemplate';
import byStage from './routes.byStage';

export const domain = domainImport;
export const entities = {
    routes: byId,
    routeCategories: byCategory,
    routeTemplate: byTemplate,
    routeStages: byStage,
};
